var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64052 12.5L14.1405 5L12.9686 3.78906L6.64052 10.1172L3.67177 7.14844L2.4999 8.32031L6.64052 12.5ZM2.42177 2.46094C4.0624 0.820314 6.02854 1.74716e-06 8.32021 1.74716e-06C10.6119 1.74716e-06 12.565 0.820314 14.1796 2.46094C15.8202 4.07552 16.6405 6.02865 16.6405 8.32031C16.6405 10.612 15.8202 12.5781 14.1796 14.2188C12.565 15.8333 10.6119 16.6406 8.32021 16.6406C6.02854 16.6406 4.0624 15.8333 2.42177 14.2188C0.807187 12.5781 -0.000104111 10.612 -0.000104111 8.32031C-0.000104111 6.02865 0.807187 4.07552 2.42177 2.46094Z",
    fill: "#007C6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.3c5d640aa49090defdf4706d2ff6c376.svg";
export { ForwardRef as ReactComponent };